module.exports = __webpack_public_path__ + "img/advanced.db6acb32.svg";